<template>
  <div class="business-card">
    <div
      class="business-image-container"
      v-bind="$attrs"
    >
      <img
        v-if="image"
        :src="image"
        alt="Image"
        class="business-image"
      >
      <img
        v-else
        :src="placeholderImage"
        alt="Image"
        class="placeholder-image"
      >
    </div>

    <div class="business-info">
      <p class="business-title body--medium">
        {{ title }}
      </p>
      <p class="business-description body--xsmall">
        {{ description.city }}, {{ description.state }}
      </p>
    </div>
  </div>
</template>

<script>
import placeholderImage from "@/assets/bd4541986f91012fc53b9029a6935847.jpeg"

export default {
  name: 'CalicoBusinessSmallCard',
  props: {
    image: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: Object,
      required: true,
      default: () => ({
        city: '',
        state: ''
      })
    }
  },
  data() {
    return {
      placeholderImage
    }
  }
};
</script>

<style lang="scss" scoped>
.business-card {
    @include inline-space($space-small);
    align-items: center;
    cursor: pointer;
}

.business-image-container {
    @include inline-space($space-none);
    align-items: center;
    justify-content: center;
}

.business-image {
    object-fit: cover;
    width: 38px;
    height: 38px;
    border-radius: $radius-small;
}

.placeholder-image {
    width: 38px;
    height: 38px;
    background-color: $color-neutral-dark;
    border-radius: $radius-small;
}

.business-info {
    flex: 1;
}

.business-title {
    margin: 0;
    color: $color-black;
}

.business-description {
    margin: 0;
    color: $color-neutral;
}
</style>